<template>
  <!--  <el-form-item :label="name" :required="getRequire">-->
  <el-popover
    v-model="visiable"
    placement="bottom-start"
    trigger="click"
    @show="handleShow"
  >
    <template #default>
      <el-table
        ref="multipleTable"
        v-loading="loading"
        class="mb-10"
        :data="data"
        row-key="code"
        style="max-width: 95vw"
      >
        <el-table-column
          v-for="(item, index) in filedList"
          :key="index"
          :property="item.code"
          :label="item.name"
          v-bind="item.config"
        />
        <el-table-column label="操作" width="120" fixed="right" align="center">
          <template #default="scope">
            <el-popover placement="left" width="1020">
              <template #default>
                <el-descriptions title="处方详情" :column="4" border>
                  <template #extra>
                    <el-button
                      type="primary"
                      size="small"
                      @click="handleRowClick(scope.row)"
                    >选择</el-button>
                  </template>
                  <el-descriptions-item
                    :span="2"
                    label="名称"
                  >{{ scope.row.name }}</el-descriptions-item>
                  <el-descriptions-item :span="2" label="方剂出处">{{
                    scope.row.prescriptionSource
                  }}
                  </el-descriptions-item>
                  <el-descriptions-item :span="4" label="方剂内容">{{
                    scope.row.prescriptionContent
                  }}
                  </el-descriptions-item>
                  <el-descriptions-item :span="4" label="方剂说明">{{
                    scope.row.prescriptionDescribe
                  }}
                  </el-descriptions-item>
                  <el-descriptions-item
                    label="用药天数"
                  >{{ scope.row.dayNum }}</el-descriptions-item>
                  <el-descriptions-item
                    label="每日剂数"
                  >{{ scope.row.dayDoseNum }}</el-descriptions-item>
                  <el-descriptions-item
                    label="每日次数"
                  >{{ scope.row.dayFreq }}</el-descriptions-item>
                  <el-descriptions-item
                    label="剂数"
                  >{{ scope.row.doseNum }}</el-descriptions-item>
                  <el-descriptions-item
                    label="代加工"
                  >{{ scope.row.decoctSign|DecoctSignType }}</el-descriptions-item>
                </el-descriptions>
              </template>
              <template #reference>
                <el-button type="text" size="small">详情</el-button>
              </template>
            </el-popover>
            <el-button
              type="text"
              size="small"
              @click="handleRowClick(scope.row)"
            >选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #reference>
      <el-button class="ik-user-btn" size="mini" type="primary">
        <slot name="default" />
      </el-button>
    </template>
  </el-popover>
</template>

<script>
import { DataTableMixin } from "@/components/ik/form/popup/mixins/tableMethodFindByKeyWord"
import { getById } from "@/api/ik/data/dataApi"

export default {
  name: "IkFormPopupSelect",
  filters: {
    /**
     * 代加工类型
     * @param val
     * @returns {string}
     * @constructor
     */
    DecoctSignType(val) {
      switch (val) {
        case "00":
          return "不加工"
        case "01":
          return "代煎"
        case "11":
          return "制粒"
        case "21":
          return "细粉打粉"
        case "22":
          return "粗粉打粉"
        case "31":
          return "水丸制丸"
        case "32":
          return "蜜丸制丸"
        case "33":
          return "大蜜丸制丸"
        case "34":
          return "浓缩丸制丸"
        case "35":
          return "水蜜丸制丸"
        case "41":
          return "制瓶装膏"
        case "42":
          return "制袋装膏"
        case "43":
          return "制块装膏"
        default:
          return ""
      }
    }
  },
  mixins: [DataTableMixin],
  props: {
    require: {
      type: Boolean,
      default: false
    },
    name: { type: String, default: "" },
    code: { type: String, default: "" },
    value: { type: String, default: "" },
    valueCode: { type: String, default: "code" }
  },
  data() {
    return {
      result: "",
      visiable: false,
      filedList: [
        { code: 'name', name: '名称', config: { align: "center", width: 120 }},
        { code: 'symContent', name: '主诉', config: { align: "center", width: 280 }},
        { code: 'fdmContent', name: '四诊', config: { align: "center", width: 280 }},
        { code: 'diagContent', name: '西医病', config: { align: "center", width: 280 }},
        { code: 'chDiagContent', name: '中医病', config: { align: "center", width: 280 }},
        { code: 'chYndromeContent', name: '中医症', config: { align: "center", width: 280 }},
        { code: 'chTherapyContent', name: '治法', config: { align: "center", width: 280 }}
        // { code: 'prescriptionSource', name: '方剂出处', config: { align: "center", width: 120 }},
        // { code: 'prescriptionContent', name: '方剂内容', config: { align: "center", width: 120 }},
        // { code: 'prescriptionDescribe', name: '方剂说明', config: { align: "center", width: 120 }},
        // { code: 'dayNum', name: '用药天数', config: { align: "center", width: 80 }},
        // { code: 'dayDoseNum', name: '每日剂数', config: { align: "center", width: 80 }},
        // { code: 'dayFreq', name: '每日次数', config: { align: "center", width: 80 }},
        // { code: 'doseNum', name: '剂数', config: { align: "center", width: 80 }},
        // { code: 'decoctSign', name: '代加工', config: { align: "center", width: 120 }}

      ]
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  watch: {
    value(val) {
      this.result = val
    }
  },
  mounted() {
    this.result = this.value
    this.search()
  },
  methods: {
    /**
     * 显示事件
     */
    handleShow() {
      this.$emit("show")
    },
    /**
     * 关闭
     */
    closepop() {
      this.visiable = false
    },
    /**
     * 行被点击
     * @param row
     */
    handleRowClick(row) {
      getById(this.url, row.id)
        .then(res => {
          this.$emit("onPopupClick", res.data)
          this.visiable = false
        })
    }
  }
}
</script>

<style scoped>
::v-deep.require > .el-input__inner {
  border: red 1px solid;
}

.item {
  width: calc(100% - 30px)
}
</style>
<style lang="scss" scoped>
.tag-wrapper {
  min-height: 24px;
  max-width: 295px;
  flex-wrap: wrap;
}

.el-form-item {
  margin-bottom: 12px;
  width: 100%;
}

.el-form-item__label {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-form-item__content {
  width: calc(100% - 180px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

